export type LocalePreferenceCookieOptions = {
  path: '/';
  sameSite: 'lax';
  maxAge?: number;
  secure?: true;
};

/**
 * Cookie options for locale preference cookies.
 * Pass `maxAge` for persistent cookies; omit it for a session cookie.
 */
export default function getLocalePreferenceCookieOptions(
  maxAge?: number,
): LocalePreferenceCookieOptions {
  return {
    path: '/',
    sameSite: 'lax',
    ...(typeof maxAge === 'number' ? { maxAge } : {}),
    ...(typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? { secure: true as const }
      : {}),
  };
}
